import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'
// 安装：npm install js-cookie
import Cookies from 'js-cookie'; 

// 打包的时候用
axios.defaults.baseURL = '/dev-api';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;

// 打包的时候要打开
// 获取 CSRF token 的函数
function getCSRFToken() {
    return Cookies.get('csrftoken') || '';
  }

const Baseurl = "https://www.saray.vip/"
// const Baseurl = "http://127.0.0.1:8000/"
// create an axios instance
const service = axios.create({
    baseURL: Baseurl, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())) {
            config.headers['X-CSRFToken'] = getCSRFToken();
        }
        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['token'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {

        const res = response.data.results ? response.data.results : response.data


        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 200) {
            Message({
                message: res.error || '系统出错，联系管里员',
                type: 'error',
                duration: 3 * 1000
            })


            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // to re-login
                MessageBox.confirm('您已注销，您可以取消以保留此页面，或再次登录', '确认注销', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                })
            }

            return Promise.reject(new Error(res.error || '系统出错，联系管里员'))
            // return res.error|| '系统出错，联系管里员'
        } else {

            return res
        }
    },
    error => {
        if(error.response.status === 401){
            Message({
                message: '登录过期，请重新登录',
                type: 'error',
                duration: 5 * 1000
            }) 
        }else if(error.response.status === 403){
            Message({
                message: '登录过期，请重新登录',
                type: 'error',
                duration: 5 * 1000
            })
        }else {
            Message({
                message: error,
                type: 'error',
                duration: 5 * 1000
            })
        }

        return Promise.reject(error)
    }
)

export default service
